<script>
  import dayjs from 'dayjs'
  import localizedFormat from 'dayjs/plugin/localizedFormat'
  import Card from '../../../components/card.svelte'
  import DataTable from '../../../components/data_table.svelte'
  import Paginator from '../../../components/paginator.svelte'
  import VisibilityBadge from '../../../components/badges/visibility_badge.svelte'
  import StateChip from '../../../components/badges/state_chip.svelte'
  import { FLAGGED, HIDDEN } from '../../../components/badges/chip_maps.js'
  import ClickableImage from '../../../components/lightbox/clickable_image.svelte'
  import ClickableVideo from '../../../components/lightbox/clickable_video.svelte'

  dayjs.extend(localizedFormat)

  let { moments } = $props()

  const records = $derived(moments?.records ?? [])
  const pagy = $derived(moments?.pagy ?? { page: 1, pages: 1, count: 0 })
</script>

<Card title="Moments">
  {#snippet actions()}
    <span class="badge badge-ghost">{pagy.count}</span>
  {/snippet}

  <DataTable items={records} emptyMessage="No moments.">
    {#snippet header()}
      <tr>
        <th>Media</th>
        <th>Place</th>
        <th>Visibility</th>
        <th>Hypes</th>
        <th>Status</th>
        <th>Date</th>
      </tr>
    {/snippet}
    {#snippet row(moment)}
      <tr>
        <td>
          {#if moment.video_url}
            <ClickableVideo url={moment.video_url} thumbnailUrl={moment.thumbnail_url} thumbClass="h-14 w-14 object-contain bg-base-200 rounded-box" />
          {:else if moment.thumbnail_url}
            <ClickableImage url={moment.thumbnail_url} title="moment" thumbClass="h-14 w-14 object-contain bg-base-200 rounded-box" />
          {:else}
            <span class="text-base-content/40">—</span>
          {/if}
        </td>
        <td>
          {#if moment.place?.url}
            <a href={moment.place.url} class="link link-hover">{moment.place.name}</a>
          {:else}
            {moment.place?.name || '—'}
          {/if}
        </td>
        <td><VisibilityBadge visibility={moment.visibility} /></td>
        <td>{moment.hypes_count}</td>
        <td>
          <div class="flex gap-1">
            {#if moment.hidden}<StateChip label="Hidden" tone={HIDDEN} />{/if}
            {#if moment.flagged}<StateChip label="Flagged" tone={FLAGGED} />{/if}
            {#if !moment.hidden && !moment.flagged}<span class="text-base-content/40">—</span>{/if}
          </div>
        </td>
        <td>{dayjs(moment.created_at).format('ll')}</td>
      </tr>
    {/snippet}
  </DataTable>

  <Paginator {...pagy} />
</Card>
